import SJTakeFace from '@/components/SJTakeFace'
import { updatePlayer } from '@/services/player'
import { PlayerReq } from '@/services/types/player'
import { Dialog } from 'antd-mobile'
import { useLocation, useNavigate } from 'react-router-dom'
import './index.less'

type Params = {
  type: 'add' | 'edit'
  playerId?: string
}

const PlayerFace = () => {
  document.title = '棋手人脸'
  const navigate = useNavigate()
  const { state } = useLocation()
  const { type = 'edit', playerId = '' } = state as Params

  const handleSuccess = async (id: string) => {
    if (type === 'add') {
      navigate('/player/name', { state: { type, playerId, faceId: id } })
    }
    if (type === 'edit') {
      editPlayer(id)
    }
  }

  const editPlayer = async (faceId: string) => {
    if (!playerId) return
    try {
      const params: PlayerReq = {
        playerId,
        faceId,
      }
      await updatePlayer(params)
      navigate(-2)
    } catch (error) {
      console.log(error)
    }
  }

  const handleJump = () => {
    Dialog.confirm({
      title: '绑定人脸识别',
      content: '人脸ID录入后可以在设备端自动识别登录，不录入ID可通过在机器人设置中进行登录',
      confirmText: '继续绑定',
      cancelText: '以后再说',
      onConfirm: async () => {},
      onCancel: async () => {
        if (type === 'add') {
          navigate('/player/name', { state: { type, playerId } })
        } else {
          navigate(-2)
        }
      },
    })
  }

  return <SJTakeFace onSuccess={handleSuccess} onCancel={handleJump} />
}
export default PlayerFace
